let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("f6bts")).then(() => parcelRequire('2Jysk'));